/**
 * Copies text and always resolves — the async Clipboard API needs a user
 * activation and a permissive context, and when it rejects, an awaited call
 * before a setState silently ate the UI feedback ("the copy button does
 * nothing"). Falls back to the selection+execCommand path, which works in
 * every browser a dashboard meets.
 */
export async function copyText(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    try {
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;left:-9999px;top:0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      ta.remove();
      return ok;
    } catch {
      return false;
    }
  }
}
